const checkIfDynamicContactUsed = (state, eventHandlers) => {
  let flag = false;
  state.EventListeners?.forEach((el) => {
    eventHandlers
      .find((eh) => eh.UUID === el.EventHandlerUUID)
      ?.Rules?.forEach((r) =>
        r.Actions?.forEach((a) => {
          if (
            [
              "AddStarterToDynamicContactSet",
              "AddResponderToDynamicContactSet",
              "StoreInputArgumentToDynamicContactSet",
            ].includes(a.Type)
          ) {
            flag = true;
          }
        })
      );
  });
  return flag;
};

export default checkIfDynamicContactUsed;
